<template>
    <div id="headerbRem">
        <nav :class="['navbar navbar-dark fixed-top bg-dark', { 'navbar-expand-md': menuDesktop }]" id="headerSecondary">
            <button
                class="navbar-toggler"
                type="button"
                id="activeMenuLateral"
                @click="ShowHiddenAside"
            >
                <span class="navbar-toggler-icon"></span>
            </button>
            <router-link :to="{ name: 'bRem' }" class="navbar-brand desktop" >
                bRem
            </router-link>
            <div class="btns_auth_id">
                <button class="copy_id_auth" @click="copyIdAuthCode">
                    <span class="badge badge-info">Id#</span>
                    <span class="badge badge-light">Copy</span>
                    <input type="text"  v-model="idAuth" ref="idAtuh" id="idAuth" readonly >
                </button>
                <button class="edit_auth_id" @click="openEditAuthId">
                    Edit
                </button>
            </div>
            <div class="menu-responsive" v-if="!menuDesktop">
                <span :class="[
                        'badge badge-pill badge-light numID mobile',
                        open ? 'active' : ''
                    ]"
                    @click="refreshOpen"
                >
                    <span class="titulo-cont"> {{ countPending }} Pending</span>
                </span>
                <span :class="['badge badge-pill badge-light completed mobile', completed ? 'active' : '']">
                    <span class="titulo-cont"> {{countFinished}} Completed</span>
                </span>
                <button
                    class="navbar-toggler"
                    type="button"
                    id="activeMenuAvanzado"
                    @click="ShowHiddenMA"
                >
                    <i class="fas fa-ellipsis-v"></i>
                </button>
            </div>
            <div :class="['collapse navbar-collapse', activarMA ? 'in' : '']"
                class=""
                id="navbarCollapse"
            >
                <div class="row" style="width: 100%">
                    <div class="col-sm-2 col-xl-4">
                        <!-- <button class="btn btn-primary btn-sx">
                            <i class="fa fa-plus"></i>
                            Add New
                        </button> -->
                    </div>
                    <div class="col-sm-7 col-xl-4 text-center" style="padding-top: 2px">
                        <span
                            v-bind:class="[
                                'badge badge-pill badge-light numID desktop',
                                open ? 'active' : '',
                            ]"
                            @click="refreshOpen"
                        >
                            <!-- <span class="badge badge-pill badge-danger num-cont"></span> -->
                            <span class="titulo-cont">{{ countPending }} Pending</span>
                        </span>
                        <span :class="['badge badge-pill badge-light completed desktop', completed ? 'active' : '']">
                            <span class="titulo-cont">{{countFinished}} Completed</span>
                        </span>
                    </div>
                    <div class="col-sm-3 col-xl-4 ">
                        <ul class="navbar-nav" style="justify-content: flex-end">
                            <li class="nav-item">
                                <a
                                    href="https://photo.marketea.app/"
                                    target="_blank"
                                    class="nav-link"
                                >
                                    <i class="fas fa-external-link-alt"></i>
                                    <span class="mobile"> App</span>
                            </a>
                            </li>
                            <li class="nav-item dropdown" @mouseleave="closeSettingsDropdown">
                                <a href="#" class="nav-link dropdown-toggle" @click.prevent="toggleSettingsDropdown"
                                    :aria-expanded="settingsDropdownOpen">
                                    <i class="fas fa-cog fa-lg"></i>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" v-show="settingsDropdownOpen">
                                    <a class="dropdown-item" href="#" @click.prevent="openSetting('otpSetting')">Otp Setting</a>
                                    <a class="dropdown-item" href="#">Option2</a>
                                    <a class="dropdown-item" href="#">Option3</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
        <modal name="optSetting" width="600" height="450" :adaptive="true" @before-close="resetModal">
            <component :is="settingComponent"></component>
        </modal>
        <modal name="editAuthId" width="600" height="450" :adaptive="true" @before-close="resetModal">
            <component :is="settingComponent" @saveCustomId="getOtpSetting"></component>
        </modal>
    </div>
</template>
<script>
// @ts-ignore
import { mapMultiGetters } from "@/core/utils/vuex";
import otpSetting from "@/apps/bRem/components/otpSetting.vue";
import editAuthId from "@/apps/bRem/components/editAuthId.vue";
export default {
    components: {
        otpSetting,
        editAuthId,
    },
    name: "headerSecundary",
    data() {
        return {
			// @ts-ignore
			org_id: window.localorgdata,
			// @ts-ignore
			user_id: window.master_client,
            menuDesktop: true,
            isLoading: false,
            url: null,
            activar: false,
            lateral: true,
            open: true,
            completed: false,
            activarMA: false,
            mainDropdownOpen: false,
            settingsDropdownOpen: false,
            windowWidth: 0,
            idAuth: null,
            settingComponent: null,
        };
    },
    created() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
        this.getOtpSetting();
    },
    methods: {
        toggleSettingsDropdown() {
            this.settingsDropdownOpen = !this.settingsDropdownOpen;
            if (this.mainDropdownOpen) this.mainDropdownOpen = false;
        },
        closeSettingsDropdown() {
            this.settingsDropdownOpen = false;
        },
        ShowHiddenAside() {
            this.lateral = !this.lateral;
            this.$store.commit("ModApps/bRem/ActiveLateral", this.lateral);
        },
        refreshOpen() {
            if (this.$router.currentRoute.name != "bRem") {
                this.$router.push({ name: "bRem" });
            } else {
                let pushRefresh = this.$store.getters["ModApps/bRem/get_refresh_list"] + 1;
                this.$store.commit("ModApps/bRem/set_refresh_list", pushRefresh);
            }
        },
        ShowHiddenMA() {
            this.activarMA = !this.activarMA;
        },
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        copyIdAuthCode() {
            const element = document.querySelector("#idAuth");
            const value = element?.value || element?.textContent || '';

            if (!value) return;

            navigator.clipboard.writeText(value)
            .then(() => {
                this.$swal({
                    icon: "success",
                    title: "Code copied",
                    timer: 1000,
                    showConfirmButton: false,
                });
            })
            .catch((err) => {
                console.error("Unable to copy code:", err);
                this.$swal({
                    icon: "error",
                    title: "Copy failed",
                    text: "Please copy manually",
                });
            });
        },
        openSetting(comp) {
            this.closeModal();
            this.settingComponent = comp;
            this.$modal.show("optSetting")
        },
        openEditAuthId() {
            this.closeModal();
            this.settingComponent = 'editAuthId';
            this.$modal.show("editAuthId")
        },
		resetModal(){
            console.log('resetModal');
			this.settingComponent=null;
		},
		closeModal(){
			this.$modal.hide('optSetting');
			this.$modal.hide('editAuthId');
		},
        getOtpSetting(){
			let t = this;
				// @ts-ignore
			window.master.post('bRem/getOtpSetting', {
				org_id: this.org_id,
				user_id: this.user_id,
			})
			.then((response) => {
				console.log('getOtpSetting loaded', response.data);
                if(!response.data.otpSetting){
                    this.openSetting('otpSetting');
                    this.idAuth = this.user_id + this.org_id.padStart(4, '0');
                }
                else {
                    if(response.data.otpSetting.custom_id){
                        this.idAuth = response.data.otpSetting.custom_id;
                    } else {
                        this.idAuth = this.user_id + this.org_id.padStart(4, '0');
                    }
                }
            }).catch((error) => {
                this.idAuth = this.user_id + this.org_id.padStart(4, '0');
				console.log(error);
                this.$store.commit('core/setNotiPush', {
                    show: true,
                    group: "notiPush",
                    type: '3', // 1=success|2=info|3=error|4=loading|5=warning
                    title: 'Error',
                    text: error.message ?? 'Server error.',
                    duration: 5000
                });
			});
        },
    },
    computed: {
		...mapMultiGetters([
			["ModApps/bRem", {
                showAside: "lateral",
				refresh_list: "get_refresh_list",
				countPending: "get_pending",
				countFinished: "get_finished",
            }],
			["core", {
				accitonPusher: "get_accitonPusher",
				getOpenModal: "getOpenModal",
			}],
		]),
    },
    watch: {
        windowWidth(newVal) {
            console.log("Nuevo ancho:", newVal);
            // aquí reaccionas a cambios
            this.menuDesktop = newVal >= 768; // ejemplo: cambiar a menú de escritorio si el ancho es mayor o igual a 768px
        },
        $route(to, from) {
            this.url = to.name;
            console.log("lectura de route", to, this.$route.params)
            if(to.name == "bRem") {
                this.open = true;
                this.completed = false;
            }
            else if(to.name == "bRemComplete"){
                this.open = false;
                this.completed = true;
            }
            else{
                this.open = false;
                this.completed = false;
            }
        },
        isLoading: function () {
        },
    },
};
</script>
<style lang="scss" scoped>
span.badge.badge-pill.badge-info.check-done {
    width: 120px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
/* Opcional: puedes usar las clases de Bootstrap CSS para estilos */
.dropdown-menu {
	display: block;
	/* Bootstrap usa esto con JS */
	position: absolute;
}
.dropdown-menu[v-cloak] {
	display: none;
}
#headerbRem {
    position: relative;
}
#headerbRem nav.navbar.fixed-top {
    top: 40px;
    background-color: #343435 !important;
    padding: 2px 0px 2px 10px;
    width: 100%;
}
#activeMenuLateral {
    display: block;
    margin-right: 10px;
    border: 0;
    padding: 0;
}
span.badge.badge-pill.badge-light.active {
    border: 1px solid #ddd;
    color: #ddd;
}
span.badge.badge-pill.badge-light {
    background-color: transparent;
    border: 1px solid #989898;
    color: #989898;
    padding: .5em 2em;
    border-radius: 10px;
    cursor: pointer;
}
span.badge.badge-pill.badge-light {
    margin-left: 10px;
}
span.badge.badge-pill.badge-light:first-child {
    margin-left: 0px;
}
.titulo-cont {
    font-size: 16px;
}
.num-cont {
    font-size: 16px;
    padding: 0px 10px;
    margin-right: 10px;
    font-family: monospace;
}
.desktop {
    display: inline-block;
    @media(max-width: 768px) {
        display: none;
    }
}
.mobile {
    display: none;
    @media(max-width: 768px) {
        display: block;
    }
}
.menu-responsive {
    display: flex;
    padding: 2px 3px;
}
.btns_auth_id{
        display: flex;
        justify-content: center;
        align-items: center;
    .copy_id_auth {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        box-shadow: 0px;
        border-radius: 0px;
        border: 0px;
        &:hover {cursor:pointer;}
        &:focus {outline: none;}
        span.badge {
            padding: 6px 5px;
            border-radius: 0px;
            &:hover {cursor:pointer;}
        }
        input#idAuth {
            letter-spacing: 3px;
            font-weight: bold;
            border-radius: 0px;
            border: 0px;
            padding: 2px 4px;
            width: 115px;
            &:hover {cursor:pointer;}
        }
    }
    .edit_auth_id {
        padding: 2px 5px;
        box-shadow: 0px;
        border-radius: 0px;
        border: 0px;
        display: flex;
        background: #fff;
        height: 100%;
        border-left: 1px solid #ddd;
        &:hover {cursor:pointer;}
    }
}
</style>
